export default "__VITE_ASSET__CFpVT$03__"